export class Line {
  id: number;
  name: string;

  constructor(id: number = null, name: string = null) {
    this.id = id;
    this.name = name;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/line.ts